import React, { useState } from "react";
import { Button, Box, CircularProgress, Menu, MenuItem } from "@mui/material";
import { Export as ExportIcon } from "iconsax-react";
import { reportsFilterPillSx, reportsDropdownPaperSx } from "./reportsFilterStyles";

// Shared Export button -- same pill/icon markup the Overview filter bar
// already used, extracted 2026-08-13 so the category drill-down header can
// reuse it instead of a second copy drifting apart over time (same reason
// ReportsDateRangeControl/reportsFilterPillSx were extracted earlier).
//
// 2026-09-08: now opens a small menu with a single "Export as CSV" item
// instead of exporting on click directly -- Rahim's ask, framed as the
// first step before more export formats might get added later (this is
// exactly why it's a real Menu here, not a Dialog/confirm -- adding a 2nd
// MenuItem later is a one-line change). Real CSV export itself is unchanged
// (downloadCsv, see reports-csv-export-and-customize-columns memory) --
// only the entry point gained a menu; `onExportCsv` fires the same handler
// the old bare `onClick` used to.
// `loading` (2026-09-11) -- category exports now loop over every page
// server-side instead of just the one on screen, so they can take a moment
// on a wide date range. Swaps the icon for a spinner and disables the
// button for that duration so a second click can't fire an overlapping
// export; Overview's export is synchronous/local so it never sets this.
const ReportsExportButton = ({ onExportCsv, loading, ...props }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleExportCsv = () => {
    setAnchorEl(null);
    onExportCsv?.();
  };

  return (
    <>
      <Button
        variant="outlined"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        disabled={loading}
        startIcon={
          <Box sx={{ width: 18, height: 18, display: "flex", alignItems: "center", justifyContent: "center" }}>
            {loading ? <CircularProgress size="1em" color="inherit" /> : <ExportIcon size="100%" color="currentColor" />}
          </Box>
        }
        sx={{
          ...reportsFilterPillSx,
          color: "text.primary",
          fontWeight: 600,
          "& .MuiButton-startIcon": { color: "text.primary" },
        }}
        {...props}
      >
        {loading ? "Exporting…" : "Export"}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: { sx: { mt: 0.75, ...reportsDropdownPaperSx } },
        }}
      >
        <MenuItem
          onClick={handleExportCsv}
          sx={{ fontSize: "0.9rem", py: 0.95, px: 1.625, mb: 0.25, borderRadius: "8px", mx: 0.5, gap: 1 }}
        >
          <Box sx={{ width: 18, height: 18, display: "flex", alignItems: "center", justifyContent: "center", color: "text.secondary" }}>
            <ExportIcon size="100%" color="currentColor" />
          </Box>
          Export as CSV
        </MenuItem>
      </Menu>
    </>
  );
};

export default ReportsExportButton;
